module.exports = __webpack_public_path__ + "static/media/5 - Catastrophe - Maintenant ou jamais.8d02fe02.mp3";